import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_THEME_SETTINGS: {
        url: "theme-settings",
        method: "get",
    },

    SAVE_THEME_SETTINGS: {
        url: "theme-settings",
        method: "post",
    },
};

export const useThemeSettings = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_THEME_SETTINGS, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        dedupingInterval: 0,
    });

export const useSaveThemeSettings = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_THEME_SETTINGS);